module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic3-mobile.e367a1eb.jpg";